import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { UserTenantDto } from 'shared';
import { UserDto } from 'shared';
import { AccountService } from 'shared';
import { NotificationService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'confirm-tenant-user',
    templateUrl: './confirm-tenant-user.component.html',
    styleUrls: ['./confirm-tenant-user.component.scss'],
    standalone: false
})
export class ConfirmTenantUserComponent implements OnInit {
  @Input('userTenant') userTenant!: UserTenantDto; 
  @Input('baseUser') baseUser!: UserDto; 
  @Input('stayExpanded') stayExpanded!: boolean; 
  

  @Output() onChangeTenantUser: EventEmitter<UserDto> = new EventEmitter();

  userTenantForm!: UntypedFormGroup;
  //userMainForm!: FormGroup;
  
  user!: UserDto;
  isRelevantUser: boolean = false;
  tenantVisible = true;

  // Ablehnen mit Begruendung (wie in der squirrel-login-Vorlage): "Ablehnen"
  // oeffnet zunaechst nur das Begruendungsfeld, erst "Ablehnung bestaetigen"
  // fuehrt die eigentliche Ablehnung aus.
  ablehnenAktiv = false;
  begruendungEntwurf = '';

  // wie mandantWarBestaetigt in der Vorlage: einmal bestaetigt gewesen -
  // "Ablehnen" ergibt dann keinen Sinn mehr, auch wenn eine spaetere Aenderung
  // der Telefonnummer die Karte kurzzeitig wieder "offen" erscheinen laesst.
  warBestaetigt = false;

  constructor(
    public translate: TranslateService,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private accountService: AccountService,
    private tenantService: TenantService
  )
   {

   }

  ngOnInit() {

    // if(this.stayExpanded)
    //   this.tenantVisible = true;
    // else
    this.tenantVisible = !this.userTenant.isConfirmed;
    this.warBestaetigt = this.userTenant.isConfirmed;

    if(this.userTenant.tenantName != "Basis"){

      console.log("--------> confirm-tenant-user: userTenant = ", this.userTenant);
      this.tenantService.getUser(this.userTenant.tenantName, this.userTenant.userId).subscribe({

        next:(userDto:UserDto) => { 
          this.user = userDto;
          if (this.user) {
            this.createUserTenantForm();
            this.isRelevantUser = true;
          }
        },
        error: (error: any) => {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "User not found in tenant");  
        }
      });

    }
  }

  createUserTenantForm(){
    //console.log("----------> confirm-tenant-user createForm: user = ", this.user)
    // kein E-Mail-Feld mehr: hier stand faelschlich die eigene E-Mail des
    // Benutzers in diesem Mandanten, statt "Eingeladen von" (siehe .html).
    this.userTenantForm = this.formBuilder.group({
      phoneNumber:[this.user.phoneNumber, [Validators.maxLength(50), Validators.pattern(/^[0-9 +\-()./]*$/)]],
    });

    // eine geaenderte Telefonnummer muss erneut bestaetigt werden (wie
    // mandantGeaendert() in der Vorlage) - macht den Bestaetigen-Button wieder
    // sichtbar, ohne "Ablehnen" erneut anzubieten (siehe warBestaetigt).
    this.userTenantForm.valueChanges.subscribe(() => {
      this.userTenant.isConfirmed = false;
      this.tenantVisible = true;
    });
  }

  // createUserMainForm(user: UserDto){
  //   this.userMainForm = this.formBuilder.group({
  //     email:[{value: user.email, disabled: true}],
  //     // firstName:[this.user.firstName, Validators.required],
  //     // lastName:[this.user.lastName, Validators.required],
  //     // userName:[(this.user.userName != this.user.email)?this.user.userName:null, Validators.required],
  //     phoneNumber:[user.phoneNumber],
  //   });
  // }


  confirm(){
    if (this.userTenantForm.valid) {
      var screenData = this.userTenantForm.getRawValue();
      this.user.userName = this.baseUser.userName;
      this.user.emailConfirmed = true;
      this.user.first_Name = this.baseUser.first_Name;
      this.user.last_Name = this.baseUser.last_Name;
      // if(this.user.phoneNumber != screenData.phoneNumber){
      //   // s.th. changed ==> stay expanded
      //   this.tenantVisible = true;
      //   console.log("------> s.th. changed")
      // }
      this.user.phoneNumber = screenData.phoneNumber;
      console.log("------> confirm-tenant-user user = ", this.user)

      this.tenantService.updateUserConfirmed(this.userTenant.tenantName, this.user).subscribe({
        next:(userDto:UserDto) => { 
          this.user = userDto;
          // this.onChangeTenantUser.emit(this.user);
          this.userTenant.isConfirmed = true;
          this.warBestaetigt = true;
          this.tenantService.updateUserTenancy(this.userTenant).subscribe({
            next:(userTenantDto:UserTenantDto) => { 
              //this.userTenant = userTenantDto;
              this.onChangeTenantUser.emit(this.user);
            },
            error: (error: any) => {
            }
          });
    

        },
        error: (error: any) => {
        }
      });

      // this.userTenant.isConfirmed = true;
      // this.tenantService.updateUserTenancy(this.userTenant).subscribe({
      //   next:(userTenantDto:UserTenantDto) => {
      //     this.userTenant = userTenantDto;
      //     this.onChangeTenantUser.emit(this.user);
      //   },
      //   error: (error: any) => {
      //   }
      // });

    }

  }

  /** "Ablehnen" verwandelt die Karte in das Begruendungsfeld, ohne schon abzulehnen. */
  ablehnenBeginnen(): void {
    this.ablehnenAktiv = true;
    this.begruendungEntwurf = '';
  }

  /** "Abbrechen" im Begruendungsfeld: zurueck zur normalen Karte, nichts geaendert. */
  ablehnenAbbrechen(): void {
    this.ablehnenAktiv = false;
    this.begruendungEntwurf = '';
  }

  /** "Ablehnung bestaetigen": fuehrt die eigentliche Ablehnung mit Begruendung aus. */
  ablehnenBestaetigen(): void {
    const begruendung = this.begruendungEntwurf.trim();
    if (!begruendung || !this.userTenantForm.valid) return;

    var screenData = this.userTenantForm.getRawValue();
    this.user.userName = this.baseUser.userName;
    this.user.emailConfirmed = this.baseUser.emailConfirmed;
    this.user.first_Name = this.baseUser.first_Name;
    this.user.last_Name = this.baseUser.last_Name;
    // if(this.user.phoneNumber != screenData.phoneNumber){
    //   // s.th. changed ==> stay expanded
    //   this.tenantVisible = true;
    //   console.log("------> s.th. changed")
    // }
    console.log("------> refuse user = ", this.user)

    this.tenantService.updateUserConfirmed(this.userTenant.tenantName, this.user).subscribe({
      next:(userDto:UserDto) => {
        this.user = userDto;
        // this.onChangeTenantUser.emit(this.user);
        this.userTenant.isRejected = true;
        // rejectionReason: noch keine DB-Spalte, siehe UserTenantDto - rein
        // lokal am userTenant-Objekt, geht beim naechsten frischen Laden von
        // "Benutzerprofil" verloren, bis das Backend ein Feld dafuer hat.
        this.userTenant.rejectionReason = begruendung;
        this.tenantService.updateUserTenancy(this.userTenant).subscribe({
          next:(userTenantDto:UserTenantDto) => {
            //this.userTenant = userTenantDto;
            this.ablehnenAktiv = false;
            this.onChangeTenantUser.emit(this.user);
          },
          error: (error: any) => {
          }
        });


      },
      error: (error: any) => {
      }
    });
  }
}
